module.exports = __webpack_public_path__ + "static/feature-board-242672fc336b64baf11ac60d54914bc3.jpg";